const handleChangeAnnual = (templateData, val) => {
  templateData.pageState.state.inputs.userInput.inputViews.inputAnnual = val
  templateData.pageState.setState({
    ...templateData.pageState.state,
  })
}

export default handleChangeAnnual
